import apiClient from "./apiClient";

const withoutEmpty = (params) =>
  Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== "" && value != null),
  );

// Seminar  { id, title, description, type, mode, venue, meetingLink, facilitator, startAt, endAt,
//            hours, capacity, branchName, openEnrollment, status: "SCHEDULED"|"COMPLETED"|"CANCELLED",
//            phase: "UPCOMING"|"ONGOING"|"ENDED", cancelReason, skills: [{ id, name, category }],
//            seatsLeft?, canEnroll,
//            my: { status: "PENDING"|"ATTENDED"|"ABSENT"|"EXCUSED", source: "ASSIGNED"|"SELF_ENROLLED",
//                  remarks, markedAt, addedAt, checkInMethod: "SELF"|"QR"|null, locationVerified,
//                  canWithdraw } | null,
//            selfCheckIn: { available, blockedReason, usesQr, needsLocation, opensAt, closesAt } | null,
//            agreement: { cost, months, paybackRule, terms, acceptedAt, mustAccept } | null }
// The employee is taken from the access token.
export const learningService = {
  // tab: "upcoming" | "past" | "all"; status; year -> Seminar[] (not paginated)
  getMySeminars: (filters = {}) =>
    apiClient.get("/learning/my/seminars", { params: withoutEmpty(filters) }),

  getMySeminar: (id) => apiClient.get(`/learning/my/seminars/${id}`),

  // Open seminars I can still register for -> Seminar[]
  getAvailable: () => apiClient.get("/learning/my/available"),

  // A training with an agreement needs acceptAgreement (400 otherwise)
  enroll: (id, { acceptAgreement } = {}) =>
    apiClient.post(
      `/learning/my/seminars/${id}/enroll`,
      acceptAgreement ? { acceptAgreement: true } : {},
    ),

  // Assigned by HR, agreement.mustAccept -> { acceptedAt }
  acceptAgreement: (id) =>
    apiClient.post(`/learning/my/seminars/${id}/accept-agreement`, {}),

  // [{ id, seminar, cost, months, paybackRule, acceptedAt, status, startsOn, endsOn, balance, … }]
  getMyBonds: () => apiClient.get("/learning/my/bonds"),

  withdraw: (id) => apiClient.delete(`/learning/my/seminars/${id}/enroll`),

  // { employee, totals: { attended, absent, excused, pending, upcoming, hours },
  //   skills: [{ id, name, category, seminars, hours, firstAttendedAt, lastAttendedAt }],
  //   attended: [{ seminarId, title, type, mode, facilitator, startAt, endAt, hours, skills, remarks }] }
  getMyRecord: () => apiClient.get("/learning/my/record"),

  // "I'm here": { location: { latitude, longitude, accuracy } }, or nothing when
  // needsLocation is false -> { seminar, status, alreadyCheckedIn, checkedInAt, locationVerified }
  // 400/403 messages are written for the employee ("You are 9.6 km from Room A...")
  selfCheckIn: (id, location) =>
    apiClient.post(
      `/learning/my/seminars/${id}/self-check-in`,
      location ? { location } : {},
    ),

  // QR check-in (code from the scanned QR) ->
  // { seminar: { id, title, startAt, endAt, venue }, status: "ATTENDED", alreadyCheckedIn, checkedInAt }
  // 400/403 messages explain why it can't (code replaced, not open yet, closed, not on the list, cancelled)
  checkIn: (id, code) =>
    apiClient.post(`/learning/my/seminars/${id}/check-in`, { code }),
};
